// actions.js
import { createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
    getSignDisclosureInitialData: ['initialData'],
    prepareDisclosure: ['statuses'],
    onSigningEvent: ['contactsSigningStatus'],
    handleSignDisclosureError: null,
});

export default { Creators, Types };